import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import type { InventorySync } from "@/api/inventory/_models/Inventory";
import { formatDateTime, formatDayTime } from "@/app/date.utils";
import { INVENTORY_LIST_SYSTEM_LABEL } from "./inventoryList.utils";

interface InventoryListSyncedProps {
  syncs: InventorySync[];
}

/**
 * When each inventory source last synced ("Last synced Cin7 21 Oct, 22:33 eStore …");
 * hovering a source shows what its numbers were as of.
 */
export const InventoryListSynced = (props: InventoryListSyncedProps) => {
  const { syncs } = props;
  if (syncs.length === 0) return <>Not synced yet</>;

  return (
    <Stack
      aria-label="Last synced"
      direction="row"
      sx={{
        alignItems: "center",
        columnGap: 1.5,
        flexWrap: "wrap",
      }}
    >
      <Stack
        component="span"
        direction="row"
        spacing={0.5}
        sx={{ alignItems: "center" }}
      >
        <AccessTimeIcon sx={{ fontSize: 16 }} />
        <span>Last synced</span>
      </Stack>
      {syncs.map((sync) => (
        <Tooltip
          key={sync.system}
          title={`As of ${formatDateTime(sync.asOf)}`}
        >
          <Box
            component="span"
            sx={{ whiteSpace: "nowrap" }}
          >
            <Box
              component="b"
              sx={{
                color: "text.primary",
                fontWeight: 600,
              }}
            >
              {INVENTORY_LIST_SYSTEM_LABEL[sync.system] ?? sync.system}
            </Box>
            {" "}
            {formatDayTime(sync.syncedAt)}
          </Box>
        </Tooltip>
      ))}
    </Stack>
  );
};
